import { newAxiosIns } from '@/libs/axios'

const { VUE_APP_BASE_URL_NEW } = process.env

export function apiGetGroupContact(search, cursor, limit) {
  return newAxiosIns.get(`/komchat-api/api/v1/group-contact/list?cursor=${cursor}&limit=${limit}&search=${search}`)
}

export function apiImportContactFromExcel({ formData }) {
  return newAxiosIns.post('/komchat-api/api/v1/contact/import/excel', formData)
}

export function apiDownloadTemplateImportExcel() {
  return newAxiosIns.get('/komchat-api/api/v1/contact/import/excel/template', {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  })
}

// google
const url = new URL(window.location.href)
const mainDomain = url.hostname.replace('www.', '')
const path = '/group-contact/import-google'
const fullDomain = `${url.protocol}//${mainDomain}${path}`
const redirectUrl = url.hostname === 'localhost' ? 'https://dev.partner.komerce.my.id/group-contact/import-google' : fullDomain

export function apiSignInGoogle() {
  const params = {
    redirect_url: redirectUrl,
  }
  return newAxiosIns.post('/auth/api/v1/googles/sign-in', params)
}
export function apiSignOutGoogle() {
  return newAxiosIns.delete('/auth/api/v1/googles/accounts')
}
export function apiCheckConnectionGoogle() {
  return newAxiosIns.get(`/auth/api/v1/googles/is-connect?redirect_url=${redirectUrl}`)
}

export function apiSignInGoogleVerify(code) {
  const params = {
    code,
    redirect_url: redirectUrl,
  }
  return newAxiosIns.post('/auth/api/v1/googles/sign-in/verify', params)
}

export function apiGoogleContactList(cursor, limit, token) {
  const params = {
    cursor,
    limit,
    token,
  }
  return newAxiosIns.get('/komchat-api/api/v1/contact/google', { params })
}

export function apiGoogleContactImport({ contact }) {
  const params = {
    contact,
  }
  return newAxiosIns.post('/komchat-api/api/v1/contact/google/import', params)
}
